<template>
    <div class="md:w-11/12 w-full flex  sm:h-auto flex-wrap mx-auto shadow-xl bg-white p-2 ">

      <div class="w-full flex sm:w-11/12 mx-auto">
        <div class=" flex flex-row w-full">

          <div class="flex-1">
            <div class="w-max mx-auto sm:mx-0 relative">
              <a class=" cursor-pointer transition duration-500 ease-in-out   xs:flex items-center" @click="updateTicketOption('Event')" v-bind:class="{'active': ticketBookmark === 'Event', 'non-active': ticketBookmark !== 'Event'}">
                <img class=" mx-auto h-6 sm:px-4 sm:my-4 my-2" src="/img/myle/not_seeclted_event_icon.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden text-center ">My Events</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">My Events</span>
              </a>
            </div>
          </div>

          <div class="flex-1">
            <div class="w-max  mx-auto relative">
              <a class="cursor-pointer transition duration-500 ease-in-out   xs:flex items-center"  @click="updateTicketOption('Ticket')"  v-bind:class="{'active': ticketBookmark === 'Ticket', 'non-active': ticketBookmark !== 'Ticket'}">
                <img class=" mx-auto h-6 sm:px-4 sm:my-4 my-2" src="/img/myle/no_selected_ticket.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden  text-center ">My Tickets</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">My Tickets</span>
              </a>
            </div>
          </div>


          <div class="flex-1 ">
            <div class="w-max sm:float-right mx-auto sm:mx-0 relative">
              <a class="cursor-pointer transition duration-500 ease-in-out   xs:flex items-center"  @click="updateTicketOption('Ads')"  v-bind:class="{'active': ticketBookmark === 'Ads', 'non-active': ticketBookmark !== 'Ads'}">
                <img class=" mx-auto h-6 sm:px-4 sm:my-4 my-2" src="/img/myle/not_selected_ad_icon.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden  text-center ">My Ads</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">My Ads</span>
              </a>
            </div>
          </div>

        </div>
      </div>

      
    </div>
</template>
<script>
  import { mapMutations, mapState } from 'vuex';
  export default {
    name: "ticketOptionBar",
    data() {
      return {}
    },
    props: {},
    methods: {
      ...mapMutations('events', ['updateTicketOption']),
    },
    computed: {
      ...mapState('events', ['ticketBookmark']),
    }
  };
</script>
